/* eslint-disable eqeqeq */
import { object, string, number, boolean } from 'yup';
import _, { castArray } from 'lodash';

import ListRecords from './ListRecords.jsx';
import FieldBasic from './FieldBasic.jsx';
import FieldSales from './FieldSales.jsx';
import FieldDesign from './FieldDesign.jsx';
import FieldAr from './FieldAr.jsx';
import { erpStatusHelper } from '../FieldErpStatus.jsx';

const schema = (tpCurrency) => object({
  itemCode: string().required(),
  status: string().required(),
  prices: object({
    retailPrice: number().required('Retail Price is a mandatory field'),
    tradePrice: number(),
    currency: string(),
  }).test({
    test: ({ retailPrice, tradePrice, currency }) => !_.includes(tpCurrency, currency) || retailPrice == 0 || (tradePrice ?? '') !== '',
    message: 'Trade price is required',
  }).test({
    test: ({ retailPrice, tradePrice, currency }) => !_.includes(tpCurrency, currency) || retailPrice == 0 || tradePrice != 0,
    message: 'Invalid trade price',
  }).test({
    test: ({ retailPrice, tradePrice, currency }) => !_.includes(tpCurrency, currency) || retailPrice >= tradePrice,
    message: 'Please check TP Price cannot greater than RP Price',
  }),
  orgId: string()
    .trim()
    .matches(/^(?:\d+,?)+$/, 'Invalid Organization ID Format'),
  arInherit: boolean(),
  arActive: boolean(),
  arImg: string(),
  arModel: string(),
});

const defaults = {
  location: '',
  prices: {
    retailPrice: 0,
    tradePrice: 0,
    currency: '',
  },
  cloudIOOrder: '',
  order: {
    orderNo: '',
    itemNo: 0,
  },
  design: {
    design: '',
    coll: '',
    brand: '',
  },
  designVariantCode: '',
  cdc: '',
  status: '',
  itemCode: '',
  serialNo: '',
  category: '',
  width: null,
  length: null,
  size: '',
  remarks: '',
  internalRemarks: '',
  sqm: 0,
  yarnContent: '',
  orgId: '',
  quantity: 1,
  photos: [],
  artworks: [],
  showroom: '',
  quantityUnit: 'EA',
  style: '',
  shape: '',
  color: '',
  description: '',
  inherit: true,
  qr: {
    redirect: 'https://taipingshop-hk.com/shop',
  },
  esd: '',
  erpSync: {
    manualSync: false,
    lastSuccess: '',
    lastSync: '',
    errType: '',
    message: '',
  },
  arInherit: true,
  arActive: true,
  arImg: '',
  arModel: '',
};

const storedFn = (stock, design) => {
  let stored = { ...defaults };
  if (design) {
    stored = {
      ...stored,
      design,
      ...(stored.inherit
        ? {
          style: design.style,
          color: design.color,
          shape: design.shape,
          description: design.description,
        }
        : {}),
    };
  }

  if (stock) {
    ['yarnContent', 'orgId', 'showrooms', 'style', 'color', 'shape'].forEach((key) => {
      stock[key] = castArray(stock[key]).filter(Boolean).join(',');
    });
    stock.erpSync = erpStatusHelper(stock.erpSync);
    stored = { ...stored, ...stock };
    if (!stock.design) {
      stock.design = undefined;
    }
  }

  return stored;
};

export {
  ListRecords, FieldBasic, FieldSales, FieldDesign, FieldAr, schema, defaults, storedFn,
};
